import React from 'react';
import ReactModal from 'react-modal';

type QrConfirmModalProps = {
    onClick: () => void;
    isOpen: boolean;
    onClose: () => void;
  };

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      padding: 0,
      border: 0,
    },
  };
  
export default function QrConfirmModal({ onClick, isOpen, onClose }: QrConfirmModalProps) {
    return (
        <ReactModal isOpen={isOpen} style={customStyles} onRequestClose={onClose}>
            <div id={'popup-wrap'}>
                <div className={'popup-wrap device-modal'} id={'etc-modal'}>
                    <div className={'popup-cont'}>
                        <center>
                            <p>QR코드 출력시<br /><b>기존 부착된 QR코드는 파기</b>되며,<br />새로 출력되는 QR코드로<br /><b>반드시 교체</b>되어야 합니다</p>
                            <br />
                            <p>정말 출력하시겠습니까?</p>
                        </center>
                        <div className={'btn-wrap'}>
                            <button type={'button'} className={'orange_white_btn'} onClick={onClick}>
                            {'확인'}
                            </button>
                            <button type={'button'} className={'gray_white_btn'} onClick={onClose}>
                            {'취소'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
      </ReactModal>
    );
}

